import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { getValidationRules } from '../validation/validation';
import UpdatePwdComponent from '../components/profile/Profile/UpdatePwdComponent';
import { updatePasswordAction } from '../store/actions/session';
import SIGN_UP_RULES from '../validation/validationRules/signUp';
import { getCurrentUser } from './selectors/userSelectors';

const UPDATE_PWD_FORM = 'update-password';

const mapStateToProps = (state) => ({
    currentUserInfo: getCurrentUser(state),
});

const mapDispatchToProps = {
    updatePasswordAction,
}

const mergeProps = (
    { ...stateProps, currentUserInfo },
    { updatePasswordAction },
) => {
    return {
        currentUserInfo,
        onSubmit: (params) => {
            let newParams = {
                ...params,
                email: currentUserInfo.email,
                uid: currentUserInfo.uid,
            };
            const action = updatePasswordAction;
            return action(newParams);
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(reduxForm({
    form: UPDATE_PWD_FORM,
    validate: getValidationRules([
        'password',
        'confirmPassword',
        'currentPassword',
    ], Object.assign(SIGN_UP_RULES)),
})(UpdatePwdComponent));



// WEBPACK FOOTER //
// ./src/containers/UpdatePwdContainer.js